import { OrderList, OrderDisplay } from './pages';
import Paths from './paths';
import { default as Translations } from './lang/hu';

export default {
    pages: {
        OrderList,
        OrderDisplay,
    },
    paths: {
        ...Paths,
    },
    translations: {
        ...Translations,
    },
    name: 'order',
    icon: 'fa-file-invoice',
};

export { default as Paths } from './paths';



// WEBPACK FOOTER //
// ./src/modules/Order/index.ts